import { _dataLinksCollectionName } from "../../../projectSpecific/sports/dbActions/globals";
import { convertHelpers } from "../../common/convert";
import { dataFix } from "../../common/dataFix";
import { createRefPath_event } from "../../firestoreData/appData/appRefPaths";
import { dispatchConfirmationTypes, grts, responseHandlers, responseReducers } from "./reducerHelpers/dispatchProps";

const _documentDoc = '_documents'

export const rts = {
  handle_ammendDataLinks: 'handle_ammendDataLinks',
  handle_changeIndex: 'handle_changeIndex',
  handle_selectedCommon: 'handle_selectedCommon',
  handle_selectedLeft: 'handle_selectedLeft',
  handle_selectedLeftItem: 'handle_selectedLeftItem',
  handle_selectedRight: 'handle_selectedRight',
  handle_selectedRightItems: 'handle_selectedRightItems',
  handle_setDataLinks: 'handle_setDataLinks',
  handle_sortOnly: 'handle_sortOnly',
  handle_sortRelated: 'handle_sortRelated',
  handle_sortSelected: 'handle_sortSelected',
  handle_updateLinks: 'handle_updateLinks',
  handle_showDataLinker: 'handle_showDataLinker',
  handleInit_dataLink: 'handleInit_dataLink',
  ...grts
};

export const dataLinkInitialState = (initState) => {
  return { ...initState, selectedRightItems: [], currentIndex: 0, sortRelated: true, sortSelected: true }; // Return the initial state as is
};

export const dataLinkReducer = (state, action) => {

  const { type, dispatch } = action
  const { database_fns, dataLinks, selectedLeftKey, selectedLeftItem } = state

  const { handleStopUpdate } = dataLinkHandlers(dispatch)

  switch (type) {
    case rts.handleInit_dataLink:
      return { ...state, dataLinks: action.appDataLinks, allRelatedItems: getAllRelatedItems(action.appDataLinks), allRelatedDocumentItems: getAllRelatedItems(action.appDataDocuments) }

    case rts.handle_showDataLinker:
      return { ...state, showDataLinker: !state.showDataLinker }

    case rts.handle_ammendDataLinks:
      return { ...state, dataLinks: action.dataLinks, appDataDocuments_updated: action.appDataDocuments, allRelatedItems: getAllRelatedItems(action.dataLinks), allRelatedDocumentItems: getAllRelatedItems(state.appDataDocuments) };

    case rts.handle_selectedLeft:
      const selectedRelatedItems = state?.allRelatedItems?.[action.selectedLeftKey]?.relatedItems
      return { ...state, currentIndex: 1, selectedLeftKey: action.selectedLeftKey, selectedRelatedItems, selectedLeftItem: null, selectedRightKey: null, selectedRightItems: [], commonRelatedItems: null, selectedCommon: null, selectedCommonItem: null };

    case rts.handle_selectedLeftItem:
      return { ...state, selectedRightKey: null, currentIndex: 2, selectedLeftItem: action.selectedLeftItem, selectedRightItems: [], selectedCommon: null, selectedCommonItem: null };

    case rts.handle_selectedRight:
      const _selectedRightItems = dataLinks?.[selectedLeftKey]?.[selectedLeftItem?._itemKey]?.[action.selectedRightKey]
      const commonRelatedItems = findCommonRelatedItems(state.allRelatedItems, state.selectedLeftKey, action.selectedRightKey)
      return { ...state, currentIndex: 3, selectedRightKey: action.selectedRightKey, selectedRightItems: _selectedRightItems ? _selectedRightItems : [], commonRelatedItems };

    case rts.handle_selectedRightItems:
      return { ...state, selectedRightItems: action.selectedRightItems, dataLinks: getDataLinks(state, action.selectedRightItems, action.item) };

    case rts.handle_selectedCommon:
      const commonDocs = state?.appDataDocuments?.[action.selectedCommon]
      const selectedCommonItem = commonDocs ? _.sortBy(_.map(commonDocs, (cd) => cd.name)) : []
      return { ...state, selectedCommon: action.selectedCommon, selectedCommonItem }

    case rts.handle_sortRelated:
      return { ...state, sortRelated: action.sortRelated };

    case rts.handle_sortSelected:
      return { ...state, sortSelected: action.sortSelected };

    case rts.handle_sortOnly:
      return { ...state, sortOnly: action.sortOnly };

    case rts.handle_updateLinks:
      const { selectedKey } = action
      const _dataLinkData = dataFix.cleanDocumentsData(dataLinks[selectedKey])
      const refPath_dl = createRefPath_event(state?.pathViews, [_dataLinksCollectionName, selectedKey])
      database_fns.doc_set(refPath_dl, _dataLinkData, true).then(res => {
        if (state.appDataDocuments_updated) {
          const _dataDocData = state.appDataDocuments_updated ? dataFix.cleanDocumentsData(state.appDataDocuments_updated[selectedKey]) : null
          const refPath_ad = createRefPath_event(state?.pathViews, [_documentDoc, selectedKey])
          database_fns.doc_set(refPath_ad, _dataDocData, true).then(res => {
            handleStopUpdate()
          })
        } else {
          handleStopUpdate()
        }
      })
      return state

    case rts.handle_changeIndex:
      return { ...state, currentIndex: action.currentIndex };

    case rts.handleCloseConfirmation:
    case rts.handleFunctionResponse:
    case rts.handleStartUpdate:
    case rts.handleStopUpdate:
    case rts.updateError:
    case rts.updateSuccess:
    case rts.updateSuccessAlt:
      return responseReducers(state, action, { dispatch, dispatchConfirmationType: dispatchConfirmationTypes.closeAfterConfirmation, questionProps: null })

    default:
      return state;
  }
};

export const dataLinkHandlers = (dispatch) => ({
  handle_showDataLinker: () => dispatch({ dispatch, type: rts.handle_showDataLinker }),
  handle_ammendDataLinks: (dataLinks, appDataDocuments) => dispatch({ dispatch, type: rts.handle_ammendDataLinks, dataLinks, appDataDocuments }),
  handle_changeIndex: (currentIndex) => dispatch({ dispatch, type: rts.handle_changeIndex, currentIndex }),
  handleInit_dataLink: (appDataLinks, appDataDocuments) => dispatch({ dispatch, type: rts.handleInit_dataLink, appDataLinks, appDataDocuments }),
  handle_selectedCommon: (selectedCommon) => dispatch({ dispatch, type: rts.handle_selectedCommon, selectedCommon }),
  handle_sortRelated: (sortRelated) => dispatch({ dispatch, type: rts.handle_sortRelated, sortRelated }),
  handle_sortSelected: (sortSelected) => dispatch({ dispatch, type: rts.handle_sortSelected, sortSelected }),
  handle_selectedLeft: (selectedLeftKey) => dispatch({ dispatch, type: rts.handle_selectedLeft, selectedLeftKey }),
  handle_selectedLeftItem: (selectedLeftItem) => dispatch({ dispatch, type: rts.handle_selectedLeftItem, selectedLeftItem }),
  handle_selectedRight: (selectedRightKey) => dispatch({ dispatch, type: rts.handle_selectedRight, selectedRightKey }),
  handle_selectedRightItems: (selectedRightItems, item) => dispatch({ dispatch, type: rts.handle_selectedRightItems, selectedRightItems, item }),
  handle_sortOnly: (sortOnly) => dispatch({ dispatch, type: rts.handle_sortOnly, sortOnly }),
  handle_updateLinks: (selectedKey) => dispatch({ dispatch, type: rts.handle_updateLinks, selectedKey }),
  ...responseHandlers(dispatch), // Assuming responseHandlers exists and is imported
});

// const getData = (database_fns, state, callback) => {
//   const cb = (dls) => {
//     const _dataLinks = { ...dls, ...state?.appDataLinks }
//     callback(_dataLinks)
//   }
//   const refPath = createRefPath_event(state.pathViews, [_dataLinksCollectionName, _dataLinksCollectionName.substring(1)])
//   database_fns.get_data({ refPath, callback: cb, opts: { returnFirstObject: true, ignoreId: true } })
// }

const getDataLinks = (state, selectedRightItems, item) => {

  const { dataLinks, selectedLeftKey, selectedLeftItem, selectedRightKey } = state
  let _dataLinkzz = _.cloneDeep(dataLinks)

  if (selectedLeftKey && selectedLeftItem && selectedRightKey) {

    convertHelpers.createNestedObject(_dataLinkzz, [selectedLeftKey, selectedLeftItem._itemKey, selectedRightKey], true);

    const _rightArray = _dataLinkzz[selectedLeftKey][selectedLeftItem._itemKey][selectedRightKey]

    const differenceRight = _.difference(_rightArray, selectedRightItems);

    _dataLinkzz[selectedLeftKey][selectedLeftItem._itemKey][selectedRightKey] = selectedRightItems;

    try {
      _.forEach(differenceRight, (dr) => {
        _.pull(_dataLinkzz[selectedRightKey][dr][selectedLeftKey], selectedLeftItem._itemKey);
      })
    } catch (error) {
      console.log('ERROR', error)
    }


    _dataLinkzz = convertHelpers.transformData(_dataLinkzz, selectedRightKey)
    // _dataLinkzz = dataFix.cleanObject(_dataLinkzz)
  }


  return _dataLinkzz

}

const getAllRelatedItems = (dataObject) => {
  return _.mapValues(dataObject, (childObjects) => {
    const relatedItems = _.uniq(
      _.flatMap(childObjects, (child) =>
        _.keys(_.pickBy(child, _.isArray))
      )
    );

    return { relatedItems };
  });
};



const getAllRelatedItemsXXX = (dataObject) => {
  const relatedItems = {};

  // Get the list of parent object names (e.g., 'attendees', 'speakers', etc.)
  const parentKeys = Object.keys(dataObject);

  // Iterate over each parent object
  parentKeys.forEach((parentKey) => {
    relatedItems[parentKey] = { relatedItems: [] };

    // Get all keys within the current parent object (e.g., 'attendeeKey1', etc.)
    const childObjects = dataObject[parentKey];

    // Collect all the values in the child objects (these are arrays of references)
    const allReferences = _.flatMap(childObjects, (child) =>
      _.values(child).flat()
    );

    // Check each potential related parent object
    parentKeys.forEach((potentialRelatedKey) => {
      if (potentialRelatedKey !== parentKey) {
        // Get all the keys from the potential related parent
        const potentialRelatedKeys = Object.keys(dataObject[potentialRelatedKey]);

        // Check if any references match the potential related keys
        if (_.intersection(allReferences, potentialRelatedKeys).length > 0) {
          relatedItems[parentKey].relatedItems.push(potentialRelatedKey);
        }
      }
    });
  });

  console.log('relatedItems', dataObject, relatedItems)

  return relatedItems;
};

const findCommonRelatedItems = (relatedItems, selectedLeftKey, selectedRightKey) => {
  if (
    relatedItems[selectedLeftKey] &&
    relatedItems[selectedRightKey]
  ) {
    const leftRelations = relatedItems[selectedLeftKey].relatedItems;
    const rightRelations = relatedItems[selectedRightKey].relatedItems;
    // Find the intersection of the two arrays
    return _.intersection(leftRelations, rightRelations);
  }

  return [];
}; 